import { render, staticRenderFns } from "./MshipsversionFormHeader.vue?vue&type=template&id=3f4013a2"
import script from "./MshipsversionFormHeader.vue?vue&type=script&lang=js"
export * from "./MshipsversionFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports